import {Injectable} from '@angular/core';
import {AbstractControl, AsyncValidatorFn, FormGroup, ValidationErrors} from "@angular/forms";
import {UsuarioService} from "../../services/usuario.service";
import {Observable, of} from "rxjs";
import {debounce, isEmpty, map, switchMap, take} from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class ValidatorService {

    constructor(public usuarioService: UsuarioService) {

    }

    static getValidatorErrorMessage(validatorName: string, validatorValue?: any): Object {
        let config = {
            'required': 'obrigatório',
            'invalidNumber': 'deve ser numérico',
            'invalidCreditCard': 'cartão inválido',
            'email': 'e-mail inválido',
            'minlength': `deve ter pelo menos ${validatorValue.requiredLength} caracter(es)`,
            'maxlength': `deve ter no máximo ${validatorValue.requiredLength} caracter(es)`,
            'invalidCpf': 'CPF inválido',
            'invalidCnpj': 'CNPJ inválido',
            'invalidCep': 'CEP inválido',
            'invalidTelefone': 'Telefone inválido',
            'invalidUrl': 'URL inválida',
            'invalidSenha': 'As senhas não são iguais',
            'invalidDuplicadCpf': 'Já foi registrada uma solicitação para este CPF',
            'invalidDuplicadCnpj': 'Já existe Gestor Municipal cadastrado para esta prefeitura.',
            'invalidDuplicadMunicipio': 'Município já possui Gestor cadastrado e ativo!',
            'invalidDuplicatedEmail': 'O e-mail informado já está cadastrado',
        };

        return config[validatorName];
    }

    static number(control: AbstractControl): ValidationErrors | null {
        const REGEXP = /^-?[\d.]+(?:e-?\d+)?$/;
        if (REGEXP.test(control.value)) {
            return null;
        } else {
            return {'invalidNumber': true};
        }
    }

    static creditCard(control: AbstractControl): ValidationErrors | null {
        const REGEXP = /^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/;
        // Visa, MasterCard, American Express, Diners Club, Discover, JCB
        // if (control.value.match(/^(?:4[0-9]{12}(?:[0-9]{3})?|5[1-5][0-9]{14}|6(?:011|5[0-9][0-9])[0-9]{12}|3[47][0-9]{13}|3(?:0[0-5]|[68][0-9])[0-9]{11}|(?:2131|1800|35\d{3})\d{11})$/)) {
        if (REGEXP.test(control.value)) {
            return null;
        } else {
            return {'invalidCreditCard': true};
        }
    }

    static cpf(control: AbstractControl): ValidationErrors | null {
        const REGEXP = /^[0-9]{11}$/;
        // if (control.value.match(/^(?=.*[0-9]){11}$/)) {

        if (REGEXP.test(control.value)) {
            return null;
        } else {
            return {'invalidCpf': true};
        }

    }

    static cnpj(control: AbstractControl): ValidationErrors | null {
        const REGEXP = /^[0-9]{14}$/;
        // if (control.value.match(/^(?=.*[0-9]){14}$/)) {
        if (REGEXP.test(control.value)) {
            return null;
        } else {
            return {'invalidCnpj': true};
        }

    }

    existingMunicipioValidator(cod_municipio: string = ""): AsyncValidatorFn {
        return (
            control: AbstractControl
        ):
            | Promise<{ [key: string]: any } | null>
            | Observable<{ [key: string]: any } | null> => {
            {
                return control.valueChanges.pipe(
                    take(1),
                    switchMap(_ =>
                        this.usuarioService
                            .findByMunicipio(control.value)
                            .pipe(
                                map((municipio: any) => {
                                        if (!!municipio) {
                                            return {'invalidDuplicadMunicipio': true}
                                        } else {
                                            return null;
                                        }
                                    }
                                )
                            )
                    )
                );
            }
        };
    }

    existingCnpjValidator(cnpj: string = ""): AsyncValidatorFn {
        return (control: AbstractControl):
            | Promise<{ [key: string]: any } | null>
            | Observable<{ [key: string]: any } | null> => {
            {
                return control.valueChanges.pipe(
                    take(1),
                    switchMap(_ =>
                        this.usuarioService
                            .findByCnpj(control.value)
                            .pipe(
                                map((usuario: any) => {
                                        let validacao: FormGroup = <FormGroup>control.parent;
                                        let cod_usuario = validacao.controls['cod_usuario'];
                                        if (!!usuario && usuario.cod_usuario == cod_usuario.value) {
                                            return null;
                                        }
                                        if (!!usuario && usuario.num_cnpj == control.value) {
                                            return {'invalidDuplicadCnpj': true}
                                        } else {
                                            return null;
                                        }
                                    }
                                )
                            )
                    )
                );
            }
        };
    }

    existingCpfValidator(cpf: string = ""): AsyncValidatorFn {
        return (
            control: AbstractControl
        ):
            | Promise<{ [key: string]: any } | null>
            | Observable<{ [key: string]: any } | null> => {
            {
                return control.valueChanges.pipe(
                    take(1),
                    switchMap(_ =>
                        this.usuarioService
                            .findByCpf(control.value)
                            .pipe(map((usuario: any) => {

                                    if (!!usuario) {
                                        return {'invalidDuplicadCpf': true}
                                    } else {
                                        return null;
                                    }
                                }
                                )
                            )
                    )
                );
            }
        };
    }

    existingEmailValidator(email: string= ""): AsyncValidatorFn {
        return (control: AbstractControl):
            | Promise<{ [key: string]: any } | null>
            | Observable<{ [key: string]: any } | null> => {
            {
                return control.valueChanges.pipe(take(1),
                    switchMap(_ =>
                        this.usuarioService.findByEmail(control.value)
                            .pipe(map((usuario: any) => {
                                    if (usuario.data.length > 0) {
                                        return {'invalidDuplicatedEmail': true}
                                    } else {
                                        return null;
                                    }
                                })
                            )
                    )
                );
            }
        };
    }

    static cep(control: AbstractControl): ValidationErrors | null {
        //const REGEXP = /^[0-9]{5}(?:-[0-9]{3})?$/;
        // const REGEXP = /^[0-9]{5}-[0-9]{3}$/;
        const REGEXP = /^[0-9]{8}$/;
        // if (control.value.match(/^(?=.*[0-9]){11}$/)) {
        if (REGEXP.test(control.value)) {
            return null;
        } else {
            return {'invalidCep': true};
        }
    }

    static areEqual(control: FormGroup): ValidationErrors | null {

        let validacao: FormGroup = <FormGroup>control.parent;
        if (validacao) {
            let valorSenha = validacao.controls['txt_senha'];
            if (valorSenha.value == control.value) {
                return null;
            } else {
                return {'invalidSenha': true};
            }
        }
        return;
    }

    static telefone(control: AbstractControl): ValidationErrors | null {
        const REGEXP = /^[0-9]{10,11}$/;
        //if(control.value.match(/^(?=.*[0-9]){8,9}$/)){
        if (REGEXP.test(control.value)) {
            return null;
        } else {
            return {'invalidTelefone': true};
        }
    }

    static url(control: AbstractControl): ValidationErrors | null {
        const REGEXP = /^(http?|ftp?|https):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
        if (REGEXP.test(control.value)) {
            return null;
        } else {
            return {'invalidUrl': true};
        }
    }
}
